import React from 'react';

const BattleContext = React.createContext({ battle: {} });

export default BattleContext;
